<template>
  <div class="verbatims">
    <div @click.prevent="goBack()" class="back">
      <div class="icon">
        <img src="../assets/back.png" alt="back icon">
      </div>
      <a class="title-2" href="#">{{$t('back')}}</a>
    </div>
    <div v-if="touchpoint" class="title">
      <span>n°{{parseInt(step) + 1}}</span>
      <h2 class="title-1">{{touchpoint.name}}</h2>
    </div>
    <div v-if="touchpoint">
      <ul class="list-verbatims">
        <li class="positive" v-if="touchpoint.positiveVerbatim" v-for="(text, k) in touchpoint.positiveVerbatim" :key="'p' + k">
          <div class="icon">
            <img src="../assets/plus.png" alt="">
          </div>
          <p v-html="text" class="text-1">

          </p>
        </li>
        <li class="negative" v-if="touchpoint.negativeVerbatim" v-for="(text, k) in touchpoint.negativeVerbatim" :key="'n' + k">
          <div class="icon">
            <img src="../assets/minus.png" alt="">
          </div>
          <p v-html="text" class="text-1"> </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from "../api";
export default {
  data() {
    return {
      touchpoint: null
    };
  },
  computed: {
    step() {
      return this.$route.params.step;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      //this.$router.push("/trackers/" + this.$route.params.id);
    }
  },
  beforeCreate() {
    document.title = this.$t("titles.verbatim");
  },
  mounted() {
    api
      .getTracker(1)
      .then(res => {
        this.touchpoint = res.touchpoints[this.step];
      })
      .catch(e => {
        
      });
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
.title {
  position: relative;
  span {
    position: absolute;
    left: -70px;
    top: 4px;
    border: 1px solid $blue;
    padding: 5px 15px;
    border-radius: 33px;
    font-size: 0.9rem;
    color: $blue;
    font-weight: bold;
  }
  h2 {
    margin: 3em 0;
    color: $text;
  }
}
.back {
  display: flex;
  align-items: center;
  font-weight: bold;
  margin: 2em 0;
  a {
    text-decoration: none;
    color: $text;
    display: block;
    margin-left: 1em;
  }
  .icon {
    margin-right: 10px;
    border-radius: 50%;
    background-color: $blue;
    padding: 13px;
    cursor: pointer;
    img {
      display: block;
      height: auto;
      width: 18px;
    }
  }
}
.verbatims {
  width: 1000px;
  max-width: 85%;
  margin: auto;
  padding-top: 3em;
  padding-bottom: 4em;
  .list-verbatims {
    display: block;
    li {
      margin: 1.5em 0;
      background-color: #fff;
      border-radius: 4px;
      padding: 2em 2em;
      box-shadow: 1px 1px 50px #ececec;
      display: flex;
      align-items: center;
      .icon {
        margin-right: 1em;
        border-radius: 50%;
        background-color: #000;
        padding: 7px;
        img {
          display: block;
          height: auto;
          width: 16px;
        }
      }
      &.positive {
        .icon {
          background-color: $plus;
        }
      }
      &.negative {
        .icon {
          background-color: $minus;
        }
      }
      p {
        line-height: 1.2;
      }
    }
  }
}
</style>